import { ADD_RECIPE } from "../types/actions";

const initialState = {
	recipeBasicDetails: null,
	recipeIngredientList: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case ADD_RECIPE.SAVE_BASIC_DETAILS:
			return {
				...state,
				recipeBasicDetails: action.payload
			};
		case ADD_RECIPE.GET_FOOD_GROUP_LIST:
			return {
				...state,
				recipeFoodGroups: action.payload
			};
		case ADD_RECIPE.SEARCH_INGREDIENTS:
			return {
				...state,
				searchIngredientResults: action.payload
			};
		case ADD_RECIPE.GET_INGREDIENT_WEIGHTS_LIST:
			return {
				...state,
				getIngredientWeights: action.payload
			};
		case ADD_RECIPE.GET_CATEGORIES:
			return {
				...state,
				categoryList: action.payload
			};
		case ADD_RECIPE.GET_CATEGORY_GROUPS:
			return {
				...state,
				categoryGroupList: action.payload
			};
		case ADD_RECIPE.GET_RECIPE_CATEGORIES:
			return {
				...state,
				recipeCategoryList: action.payload
			};
		case ADD_RECIPE.GET_SOURCES:
			return {
				...state,
				sourceList: action.payload
			};
		case ADD_RECIPE.GET_RECIPE_SOURCES:
			return {
				...state,
				recipeSourceList: action.payload
			};
		case ADD_RECIPE.GET_IMAGES:
			return {
				...state,
				imageList: action.payload
			};
		case ADD_RECIPE.GET_RECIPE_IMAGES:
			return {
				...state,
				recipeImageList: action.payload
			};
		case ADD_RECIPE.GET_RECIPE_INGREDIENTS:
			return {
				...state,
				recipeIngredientList: action.payload
			};
		case ADD_RECIPE.SUBMIT_RECIPE:
			return {
				...state,
				userRecipe: action.payload
			};
		default:
			return state;
	}
};
